import { render, staticRenderFns } from "./ClaimsOptions.vue?vue&type=template&id=68b4f63b&scoped=true"
import script from "./ClaimsOptions.vue?vue&type=script&lang=js"
export * from "./ClaimsOptions.vue?vue&type=script&lang=js"
import style0 from "./ClaimsOptions.vue?vue&type=style&index=0&id=68b4f63b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b4f63b",
  null
  
)

export default component.exports